import React from 'react';

type PROPS = {
  target: any;
  title: string;
};

class DueDateIndicatorTooltip extends React.Component<PROPS, any> {
  render() {
    const className = (this.props.target && this.props.target.className) || '';
    return (
      <div className={className}>
        {this.props.title}
      </div>
    );
  }
}

export default DueDateIndicatorTooltip;
